module.exports = __webpack_public_path__ + "img/Photo_2__Grain_Industry_977_454_2.945cb3c2.jpg";